<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-12">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/']">
              <i class="fas fa-home"></i>
              Página Inicial</a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0);" (click)="retornoAbaRisco()"> Riscos Chaves</a>
          </li>
          <li class="breadcrumb-item active">{{ titulo }} Risco Chave - {{ nomeRiscoChaves }}</li>
        </ol>
      </div>
    </div>
  </div>
</div>

<div class="card-body p-2">
  <div class="mat-elevation-z4">
    <mat-toolbar class="table-header">
      <mat-toolbar-row>

      </mat-toolbar-row>
    </mat-toolbar>


    <table class="mat-elevation-z8 w-100 table table-bordered">
      <thead>
      <tr>
        <th>Subtipo</th>
        <th>Macroprocesso</th>
        <th>Processos</th>
        <th>Descrição do Risco-Chave</th>
        <th>Magnitude (Risco Inerente)</th>
        <th>Magnitude (Risco Residual)</th>
        <th>Ações</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let subtipo of modelTipoUniversoItens?.itens">
        <tr class="tr-cinza">
          <td><strong>{{ subtipo.ordemExibicao }} {{ subtipo.nome }}</strong></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        <ng-container *ngFor="let macro of subtipo.itens">
          <ng-container *ngIf="macro.tipo === 2">
            <tr>
              <td></td>
              <td><strong>{{ macro.ordemExibicao }} {{ macro.nome }}</strong></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <ng-container *ngIf="getMagnitude(macro.itens) as magnitude">
              <ng-container *ngFor="let processo of macro.itens">
                <ng-container *ngIf="getRiscosPorProcesso(processo.id) as riscos">
                  <ng-container *ngFor="let risco of riscos; let i = index">
                    <tr>
                      <td></td>
                      <td></td>

                      <ng-container *ngIf="i === 0">
                        <td [attr.rowspan]="riscos.length">
                          {{ processo.ordemExibicao }} {{ processo.nome }}
                        </td>
                      </ng-container>

                      <td>{{ risco.nomeRisco }}</td>
                      <td>{{ risco.ri || 0 }}</td>
                      <td>{{ risco.rr || 0 }}</td>
                      <td class="botoes-acoes">
                        <button type="button" class="btn btn-info btn-xs mr-1"
                                (click)="abrirPreenchimento(processo.id, true, subtipo.ordemExibicao + ' ' + subtipo.nome, macro.ordemExibicao + ' ' + macro.nome, processo.ordemExibicao + ' ' + processo.nome)">
                          <i class="far fa-eye"></i>
                        </button>
                        <button type="button" class="btn btn-primary btn-xs mr-1"
                                [hidden]="visualizar"
                                (click)="abrirPreenchimento(processo.id, false, subtipo.ordemExibicao + ' ' + subtipo.nome, macro.ordemExibicao + ' ' + macro.nome, processo.ordemExibicao + ' ' + processo.nome)">
                          <i class="far fas fa-pen"></i>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="getMagnitude([processo]) as magProc">
                    <tr>
                      <td></td>
                      <td></td>
                      <td colspan="2" class="text-left"><strong>Magnitude</strong></td>
                      <td><strong>{{ magProc.riTotal }}</strong></td>
                      <td><strong>{{ magProc.rrTotal }}</strong></td>
                      <td></td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
              <tr>
                <td></td>
                <td colspan="3" class="text-left"><strong>Magnitude</strong></td>
                <td><strong>{{ magnitude.riTotal }}</strong></td>
                <td><strong>{{ magnitude.rrTotal }}</strong></td>
                <td></td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="getMagnitudeMacro(subtipo.itens) as magnitudeSubtipo">
          <tr>
            <td></td>
            <td colspan="3" class="text-left"><strong>Magnitude</strong></td>
            <td><strong>{{ magnitudeSubtipo.riTotal }}</strong></td>
            <td><strong>{{ magnitudeSubtipo.rrTotal }}</strong></td>
            <td></td>
          </tr>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="getMagnitudeTotal() as magnitudeTotal">
        <tr>
          <td><strong>Magnitude</strong></td>
          <td></td>
          <td></td>
          <td></td>
          <td><strong>{{ magnitudeTotal.riTotal }}</strong></td>
          <td><strong>{{ magnitudeTotal.rrTotal }}</strong></td>
          <td></td>
        </tr>
      </ng-container>

    </table>

  </div>

  <div class="card-footer d-flex justify-content-start align-items-left">
    <button
      type="button"
      *ngIf="!habilitaBotaoFinalizar"
      class="btn btn-success btn-sm mr"
      style="height: fit-content;"
      (click)="onFinalizar()">
      <i class="fas fa-list"></i> Finalizar
    </button>


    <button
      type="button"
      style="height: fit-content;"
      class="btn btn-default btn-sm mr"
      (click)="onBack()"
    >
      <i class="fas fa-times"></i> Fechar
    </button>
  </div>

</div>



